import { type Action, can } from '@quickreport/domain';
import type { SyncEngine } from '@quickreport/sync';
import { createContext, useContext } from 'react';
import type { AuthState } from '../auth/AuthProvider';
import type { LocalDb } from '../local-db/client';

export interface Workspace {
  db: LocalDb;
  orgId: string;
  siteId: string | null;
  auth: AuthState;
  engine: SyncEngine;
}

export const WorkspaceContext = createContext<Workspace | null>(null);

export function useWorkspace(): Workspace & { can: (a: Action) => boolean } {
  const ws = useContext(WorkspaceContext);
  if (!ws) throw new Error('useWorkspace outside WorkspaceContext');
  return { ...ws, can: (a) => can(ws.auth.roles, a) };
}
